<template>
  <PgTable
    class="pg-table-drag"
    ref="tableRef"
    :stripe="stripe"
    :selectAndSeqFixed="selectAndSeqFixed"
    :rowConfig="rowConfig"
    v-bind="$attrs"
    v-on="$listeners"
  >
  </PgTable>
</template>
<script setup>
import PgTable from './table-main.vue'
import { ref, onMounted, onUnmounted } from 'vue'
import Sortable from 'sortablejs'
import { getValueByPath } from '../../../utils/index'

const props = defineProps({
  stripe: {
    type: Boolean,
    default: false,
  },
  selectAndSeqFixed: {
    type: String,
    default: '',
  },
  rowConfig: {
    type: Object,
    default: null,
  },
  dragRemove: Function,
  dragUpdate: Function,
})

const tableRef = ref(null)
onMounted(() => {
  const dom = getScrollDomByClass(tableRef.value.$el, [
    'pg-table__table',
    'vxe-table--render-default',
    'vxe-table--render-wrapper',
    'vxe-table--main-wrapper',
    'vxe-table--body-wrapper',
    'vxe-table--body',
  ])
  creatSortable(getScrollDomByNode(dom, ['tbody']))
})
onUnmounted(() => {
  if (sortableInstance) {
    sortableInstance.destroy()
  }
})
let sortableInstance = null
const creatSortable = (dom) => {
  if (!dom) {
    return
  }
  if (sortableInstance) {
    sortableInstance.destroy()
  }
  sortableInstance = Sortable.create(dom, {
    group: {
      name: 'portal',
      pull: false, //pull用来定义从这个列表容器移动出去的设置，true/false/'clone'/function
    },
    // handle: props.dragHandle,
    animation: 120,
    // ghostClass: '',
    // fallbackClass: '',
    dragClass: 'pg-form__item-drag',
    onRemove(event) {
      props.dragRemove?.(event)
    },
    onUpdate(event) {
      const { fullData, pageData } = tableRef.value.getTableData()
      const oldIndex = fullData.findIndex(
        (item) =>
          getValueByPath(item, props.rowConfig?.keyField ?? '_ID') ===
          getValueByPath(pageData[event.oldIndex], props.rowConfig?.keyField ?? '_ID')
      )
      const newIndex = fullData.findIndex(
        (item) =>
          getValueByPath(item, props.rowConfig?.keyField ?? '_ID') ===
          getValueByPath(pageData[event.newIndex], props.rowConfig?.keyField ?? '_ID')
      )
      const temp = fullData[oldIndex]
      fullData.splice(oldIndex, 1)
      fullData.splice(newIndex, 0, temp)
      const tempRowDom = event.from.childNodes[event.newIndex]
      const temDom =
        event.newIndex > event.oldIndex
          ? event.from.childNodes[event.oldIndex]
          : event.from.childNodes[event.oldIndex + 1]
      event.from.insertBefore(tempRowDom, temDom ?? null)
      tableRef.value.loadData(fullData)
      props.dragUpdate?.({
        tableData: fullData,
        event,
      })
    },
  })
}

//根据className获取dom
const getScrollDomByClass = (node, classNames) => {
  if (node?.children?.length < 1 || classNames?.length < 1) {
    return
  }
  for (let i = 0; i < node.children.length; i++) {
    if (node.children[i].className.includes(classNames[0])) {
      if (classNames.length === 1) {
        return node.children[i]
      } else {
        classNames.shift()
        return getScrollDomByClass(node.children[i], classNames)
      }
    }
  }
}
//根据标签名获取dom
const getScrollDomByNode = (node, nodeNames) => {
  if (node?.children?.length < 1 || nodeNames?.length < 1) {
    return
  }
  for (let i = 0; i < node.children.length; i++) {
    if (node.children[i].nodeName.toLowerCase().includes(nodeNames[0])) {
      if (nodeNames.length === 1) {
        return node.children[i]
      } else {
        nodeNames.shift()
        return getScrollDomByNode(node.children[i], nodeNames)
      }
    }
  }
}

defineExpose({
  loadData: (...arg) => tableRef.value.loadData(...arg),
  loadDataAsync: (...arg) => tableRef.value.loadDataAsync(...arg),
  getTableData: (...arg) => tableRef.value.getTableData(...arg),
  setCheckboxRow: (...arg) => tableRef.value.setCheckboxRow(...arg),
  setAllCheckboxRow: (...arg) => tableRef.value.setAllCheckboxRow(...arg),
  setCurrentRow: (...arg) => tableRef.value.setCurrentRow(...arg),
  setAllTreeExpand: (...arg) => tableRef.value.setAllTreeExpand(...arg),
  setTreeExpand: (...arg) => tableRef.value.setTreeExpand(...arg),
  fullValid: (...arg) => tableRef.value.fullValid(...arg),
  recalculate: (...arg) => tableRef.value.recalculate(...arg),
  clearOb: (...arg) => tableRef.value.clearOb(...arg),
  creatRowId: (...arg) => tableRef.value.creatRowId(...arg),
  getScroll: (...arg) => tableRef.value.getScroll(...arg),
  scrollTo: (...arg) => tableRef.value.scrollTo(...arg),
  scrollToRow: (...arg) => tableRef.value.scrollToRow(...arg),
})
</script>
